module.exports = __webpack_public_path__ + "static/media/IMG_0090.86f468e5.jpg";